import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// EXTRA COMPONENTS
import SkewBg from './SkewBg'
import CardBarrel from './Cards/CardBarrel'
import CardPayment from './Cards/CardPayment'
import CardWallet from './Cards/CardWallet'

export default class StandAloneSolutions extends React.Component{
    render(){
    return(
        <section id="StandAloneSolutions" className={css(styles.MainContainer)}>
            <SkewBg />
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                    <Typography 
                    variant="display1" 
                    style={{color:'white', marginBottom: 80, fontWeight: 500}}>
                        Meet our stand-alone solutions
                    </Typography>
                    <Grid  container className="container" justify="center" alignItems="center">
                        <Grid className={css(styles.GridItem)} item md={5}>
                            <CardPayment
                            title="VENTI" 
                            subtitle="Event Ticketing and Cashless Payments"
                            text="Tech ecosystem for events, cashless payments, qr access and more."
                            buttonText="See more" 
                            />

                        </Grid>
                        <Grid className={css(styles.GridItem)} item md={5}>
                        <CardWallet
                            title="LEMON CASH" 
                            subtitle="Digital Wallet and Bitcoin broker"
                            text="Send, receive and pay with LemonCash. Buy and sell cryptocurrency instantly."
                            buttonText="See more" 
                            />
                        </Grid>
                    </Grid>
                </section>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    MainContainer: {
        position: 'relative',
        minHeight: 1080,
        marginTop: 150,
        '@media (min-width: 1500px)' : {
            minHeight: 1135,
            marginTop: 104,
         }
    },
    SecondaryContainer: {
        paddingTop: '35%',
    	color: 'white',
        lineHeight: '1.8em',
        textAlign: 'center',
        '@media (max-width: 768px)': {
            paddingTop: '50%'
        }
    },
    GridItem : {
        'margin': '0 1.5em',
        '@media (max-width: 768px)' : {
            marginBottom: '2em',
            flexBasis: '80%'
        }
    },
});


// WEBPACK FOOTER //
// ./src/Components/Home/StandAloneSolutions/StandAloneSolutions.js